<gd-dialog-container [closable]="false">
  <div class="modal-container">
    <header class="d-flex flex-justify-between modal-header">
      <h2 class="modal-title" data-lokalise data-key="txt_choose_a_template"></h2>
      <div class="close-icon" (click)="closeModal()">
        <img src="/assets/checkout/close.svg" alt="close icon" />
      </div>
    </header>

    <div class="modal-body">
      <ng-container *ngIf="items?.length; else newTemplate">
        <gd-product-templates-list-search-params
          class="search-bar"
          [showSortBy]="false"
          [searchParams]="searchParams"
          (searchParamsChange)="changeSearchParams($event)"
        ></gd-product-templates-list-search-params>

        <div class="template-list-container">
          <gd-product-templates-list
            columns="three"
            infiniteScrollContainer="gd-product-templates-list"
            [items]="items"
            [showEditButton]="false"
            [showActionButtons]="false"
            [showPlaceOrderButton]="false"
            (itemClick)="addToStore($event)"
            (scrollDown)="scrollDown.emit()"
          ></gd-product-templates-list>
        </div>
      </ng-container>
    </div>
  </div>
</gd-dialog-container>

<ui-full-screen-spinner *ngIf="isLoading"></ui-full-screen-spinner>

<ng-template #newTemplate>
  <gd-product-templates-list-empty-state
    (createTemplateButtonClick)="createTemplate()"
  ></gd-product-templates-list-empty-state>
</ng-template>
